import { Source } from 'app/models/source.enum';

export class FileFilterOption {
  title: string;
  value: boolean;
  source: Source;

  constructor(title: string, value: boolean, source: Source) {
    this.title = title;
    this.value = value;
    this.source = source;
  }
}




// WEBPACK FOOTER //
// ./src/app/models/file-filter-option.ts